export const MAIN_EDITOR_TOOLTIPS = [
  {
    id: 'rotate-tool',
    cookieKey: 'editor_tip_rotate_tool',
    title: 'Rotate or Flip',
    description:
      'You can rotate your image 90 degrees clockwise or counterclockwise and flip it horizontally or vertically.',
    placement: 'right',
    align: 'center',
    delayAfterClose: 1800,
  },
  {
    id: 'adjust-tool',
    cookieKey: 'editor_tip_adjust_tool',
    title: 'Adjust',
    description:
      'Adjust brightness, contrast, saturation and hue of your photo.',
    placement: 'right',
    align: 'center',
    delayAfterClose: 1800,
  },
  {
    id: 'filter-tool',
    cookieKey: 'editor_tip_filter_tool',
    title: 'Filter',
    description:
      'Enhance your image with one-tap filter styles that adjust colour and tone.',
    placement: 'right',
    align: 'center',
    delayAfterClose: 1800,
  },
  {
    id: 'start-over',
    cookieKey: 'editor_tip_start_over',
    title: 'Start Over',
    description:
      'Use this if you want to clear your edits and go back to the original image or select a new image.',
    placement: 'bottom',
    align: 'center',
    delayAfterClose: 1800,
  },
  {
    id: 'undo-redo',
    cookieKey: 'editor_tip_undo_redo',
    title: 'Undo and Redo',
    description:
      'Use undo or redo to step backwards or forwards through your recent edits.',
    placement: 'bottom',
    align: 'center',
    delayAfterClose: 1800,
  },
  {
    id: 'test',
    cookieKey: 'editor_tip_test',
    title: 'Test',
    description: 'Testing new tooltip',
    placement: 'bottom',
    align: 'center',
    delayAfterClose: 1800,
  },
  {
    id: 'upload-image',
    cookieKey: 'editor_tip_upload',
    title: 'Upload Image',
    description:
      'Click here when your edits are complete and you are ready to add the image to your post.',
    placement: 'bottom',
    align: 'center',
    delayAfterClose: 1800,
  },
];
